import Resource from "./resource";
import {ExternalIdentityResource} from "./identityResource";

export class InvitationResource extends Resource {
    AddToTeamIds: string[]; //TODO: ReferenceCollection
    InvitationCode: string;
    Expires: string[]; //TODO: datetimeoffset
}

export default InvitationResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/invitationResource.ts